import { render } from "./Mui.vue?vue&type=template&id=d2a3ec94&scoped=true"
import script from "./Mui.vue?vue&type=script&lang=js"
export * from "./Mui.vue?vue&type=script&lang=js"

import "./Mui.vue?vue&type=style&index=0&id=d2a3ec94&scoped=true&lang=css"

import exportComponent from "/Users/tamotsu/Documents/たもつ製作所/jibi/jibi-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a3ec94"]])

export default __exports__